// extracted by mini-css-extract-plugin
export default {"layout":"adminTweet_layout__vgrsx","delBtn":"adminTweet_delBtn__7poqO","spinner":"adminTweet_spinner__emVwN"};